import { Action, ActionType } from '@store/interfaces/shipments/package-order';

const getPackages = (payload: any): Action => {
  return { type: ActionType.GET_SHIPMENT_PACKAGE_ORDER_REQUEST, payload };
};
const getPackagesSuccess = (payload: any): Action => {
  return { type: ActionType.GET_SHIPMENT_PACKAGE_ORDER_REQUEST_SUCCESS, payload };
};
const getPackagesFailure = (error?: any): Action => {
  return { type: ActionType.GET_SHIPMENT_PACKAGE_ORDER_REQUEST_FAILURE, error };
};

const clearMessageError = (): Action => {
  return { type: ActionType.CLEAR_MESSAGE_ERROR };
};

export const actions = {
  getPackages,
  getPackagesSuccess,
  getPackagesFailure,

  clearMessageError,
};

const returns = {
  actions,
};

export default returns;
